import { DateTimeRange } from '@modules/common/components/DateRangePicker/types';
import { createStore } from 'zustand';
import { devtools, redux } from 'zustand/middleware';
import { searchInitialState } from './searchInitialState';
import { searchReducer } from './searchReducer';

export const createFeedStore = (defaultTimeRange: DateTimeRange) =>
  createStore(
    devtools(
      redux(searchReducer, {
        ...searchInitialState,
        query: { ...searchInitialState.query, duration: defaultTimeRange },
      }),
      {
        name: 'FeedStore',
      },
    ),
  );
